module.exports = __webpack_public_path__ + "img/trips.9702b73b.jpg";